import React from 'react';

import { SearchAndShuffleContextProvider } from './context';
import { SearchAndShuffle } from './search-and-shuffle';
import type { HookData, HookSavedData, Config } from './types';

export type SearchAndShuffleXingletProps = {
  useData: HookData;
  useSavedData: HookSavedData;
  config: Config;
  hideSavedCards?: boolean;
  hideAds?: boolean;
};

const SearchAndShuffleXinglet: React.FC<SearchAndShuffleXingletProps> = ({
  useData,
  useSavedData,
  config,
  hideSavedCards,
  hideAds,
}) => {
  return (
    <SearchAndShuffleContextProvider config={config}>
      <SearchAndShuffle
        useData={useData}
        useSavedData={useSavedData}
        hideSavedCards={hideSavedCards}
        hideAds={hideAds}
      />
    </SearchAndShuffleContextProvider>
  );
};

export default SearchAndShuffleXinglet;
export * from './types';
export { CardModal } from './card-modal';
